import React from 'react'
import Gastronomy from './Gastronomy'
import Card from './Card'
import Contact from './Contact'
import Footer from '../components/Footer'
import useIsMobile from '../hooks/useIsMobile'

const IndexPage = ({lang, translations}) => {
  const isDeviceMobile = useIsMobile();

  return (
    <main id={"home"}>
      <img
          className={isDeviceMobile ? "logo-faro margin-top-negative" : "logo-faro margin-top-negative"}
          src="img/logos/faro_con_fondo_disfrutar_compartiendo.png"
          alt={translations[lang].logoalt}
        />
      <div className="restaurant-bg flex"></div>
     
      <Gastronomy translations={translations} lang={lang}/>
      <Card translations={translations} lang={lang}/>  
      <Contact translations={translations} lang={lang}/>      
      <Footer lang={lang} translations={translations}/>
    </main>
  )
}

export default IndexPage